(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-booking-clarity"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-hn-appointment-trigger]');
    if (!trigger) return;

    event.preventDefault();
    trigger.setAttribute('aria-busy', 'true');

    let attempts = 0;
    const openScheduler = function () {
      const schedulerButton = document.getElementById('apntly-book-button');
      attempts += 1;

      if (schedulerButton) {
        trigger.removeAttribute('aria-busy');
        schedulerButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
        schedulerButton.click();
        return;
      }

      if (attempts < 40) {
        window.setTimeout(openScheduler, 250);
      } else {
        trigger.removeAttribute('aria-busy');
        window.location.hash = 'apntly-book-button';
      }
    };

    openScheduler();
  });

  } catch(e) { console.error(e); }
})();
})();
